var ProgressIndicator = {};

ProgressIndicator.show = function () {}

ProgressIndicator.hide = function () {}

var gvtController = {
  setIfScanExist: function () {},
  runScan: function () {},
  stopScan: function () {}
};
var tagManagerController = {
  tagGoogleAnalytics: function () {},
  tagGoogleAnalyticsAction: function () {}
};

var isCGU = false;

var ddbviewer = {};

ddbviewer.finishLoadView = function () {
  pap.initPage();
}

ddbviewer.init = function () {
  rtlDirection.init();

  ddbViewerParams.init(function () {
    i18n.init({
      fallbackLng: false,
      lng: ddbViewerParams.data.lang_language,
      useCookie: false,
      detectLngFromHeaders: false,
      resGetPath: '../../../../app/assets/locales/' + ddbViewerParams.data.lang_language + '/__ns__.json'
    });

    setSizeIframe();

    $(window).resize(function () {
      setSizeIframe();
    });

    function setSizeIframe() {
      var innerWidth = $("body").innerWidth();
      var innerHeight = $("body").innerHeight();
      $("#app-content").width(innerWidth);
      $("#app-content").height(innerHeight);

      if (innerWidth > innerHeight) {
        $("body").attr("data-orientation", "landscape");

      } else {
        $("body").attr("data-orientation", "portrait");
      }
    }

    psa_params.init(function () {
      loadApplicabilityParams(function () {
        pap.init();

        const langLanguageData = ddbViewerParams.data.lang_iso.split("_");

        navigationWeb.initSummary('eguide/sommaire_' + langLanguageData[0] + "-" + langLanguageData[1] + '.xml', function () {

          rtlDirection.onChangeLanguage(langLanguageData[0]);

          initApplicability(langLanguageData[0])

          if (psa_params.data.modeXSL === true) {
            loadContent.langue = langLanguageData[0] + "-" + langLanguageData[1];
            loadContent.racine = "../../../" + ddbViewerParams.data.documentation_path + "/" + loadContent.langue;
            loadContent.pathToDoc = "../../../" + ddbViewerParams.data.documentation_path + "/";
            loadContent.racineXSL = "../../../../app/assets/";
            loadContent.racineTemplates = loadContent.racineXSL;

            loadContent.loadTemplate(function () {
              loadDDB.racine = "../../../" + ddbViewerParams.data.documentation_path + "/";
              loadDDB.init(function (success) {
                if (success) {
                  if (psa_params.data.modeEGuide === true) {
                    navigationWeb.language = langLanguageData[0]
                    initUrlPage()
                  }
                }
              })
            })
          } else {
            loadContent.racine = "../../../" + ddbViewerParams.data.documentation_path + "/" + ddbViewerParams.data.lang_language + "/"
            loadContent.pathToDoc = "../../../" + ddbViewerParams.data.documentation_path + "/"
            loadContent.racineXSL = "../../../../www/"
            loadContent.racineTemplates = loadContent.racineXSL

            loadContent.loadTemplate()
            loadContent.loadContent("../../../../www/doc/index.html", {
              targetSelector: null,
              initDoc: true
            })
          }
        })
      })
    })
  })
}

function initUrlPage() {
  navigationWeb.index = 0
  const urlPage = navigationWeb.listSummary[navigationWeb.index]

  ddbLoadContent().then(() => {
    initEguideFilter()
    pap.loadPageChangeHash(urlPage, true)
    navigationWeb.updateSummaryFromIndex(navigationWeb.index)

    // TODO Rework...
    infotecEGuideBar.init(
      '../../../../app/assets/templates/infotecEGuideBar.mustache',
      '#home',
      '../../../../app/assets/wwweguide/locale',
      ddbViewerParams.data.lang_language,
      'eguide/sommaire_' + loadContent.langue + '.xml',
      'eguide/recherche_generated_' + loadContent.langue + '.xml',
      loadContent.pathToDoc + 'vehicule.xml',
      loadContent.pathToDoc + 'pdfs/',
      loadContent.langue
    )

    autocompleteSearch.init('eguide/recherche_generated_' + loadContent.langue + '.xml');
    indexAlpha.initData('eguide/indexalphabetique_generated_' + loadContent.langue + '.json');
    addendum.init(loadContent.pathToDoc + 'pdfs/', 'eguide/additifs_' + loadContent.langue + '.xml');
    print.init()

    $("body").find("[data-i18n]").i18n();
    $('input, textarea').placeholder();
  })
}

async function ddbLoadContent() {
  let pagePath = "../../../../app/assets/views/index.web.html"
  if (psa_params.data.isDoc === undefined || psa_params.data.isDoc === false) {
    pagePath = "../../../../app/assets/views/index.app.html"
  }

  return loadContent.loadContent(pagePath, {
    targetSelector: null,
    initDoc: true
  })
}

function initApplicability(lang) {
  applicabilityDoc.isSetConfigurationVehicle = true;

  // Init all configuration
  applicabilityDoc.data.listeLangues.forEach(function (_lang) {
    applicabilityDoc.allConfigurationVehicle.push("code-lang_" + _lang.key)
  })
  
  for( var key in applicabilityDoc.data.folderReference ) {
    applicabilityDoc.allConfigurationVehicle.push("code-pays_" + applicabilityDoc.data.folderReference[key])
  }

  // Set criteria
  var country = applicabilityDoc.data.folderReference[lang.toLowerCase()].toUpperCase()
  var listApplicabilities = ["code-lang_" + lang, "code-pays_" + country]
  applicabilityDoc.applicabilityCriteriaArray = listApplicabilities
}

function loadApplicabilityParams(callback) {
  $.ajax({
    url: "../../../../app/assets/data/applicabilityParams.json",
    global: false,
    dataType: "json",
    async: true,
    success: function success(data) {
      applicabilityDoc.data = data;

      callback.apply(this, []);
    },
    error: function fail() {
      callback.apply(this, []);
    }
  });
}

$(document).ready(function () {
  ddbviewer.init();
});